<template>
    <header class="header-global py-2">
        <div class="nav d-flex justify-content-end align-items-center">
            <div class="navbar-nav m-2" v-if="!showSecure">
                <div v-if="showSignIn" class="nav-item me-3">
                    <router-link v-if="isLoggedIn" to="/landing" class="btn-header-signin">
                        <LoginOutlined class="me-2"/>
                        <span>Enter</span>
                    </router-link>
                    <router-link v-else to="/login" class="btn-header-signin">
                        <LoginOutlined class="me-2"/>
                        <span>Sign In</span>
                    </router-link>
                </div>
            </div>

            <div v-if="showSecure" class="navbar-nav me-3">
                <div class="dropright">
                    <button type="button" class="header-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                        <AppstoreOutlined class="features-button"/>
                    </button>
                    <ul class="dropdown-menu">
                        <li><h6 class="dropdown-header">Dashboards</h6></li>
                        <li>
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="switchToDashboard('productcloud')"
                                :class="{ 'active': currentProduct === 'productcloud' }"
                            >
                                Product Cloud Dashboard
                            </a>
                        </li>
                        <li>
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="switchToDashboard('bankwatch')"
                                :class="{ 'active': currentProduct === 'bankwatch' }"
                            >
                                BankWatch Dashboard
                            </a>
                        </li>
                        <li>
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="switchToDashboard('cdrtest')"
                                :class="{ 'active': currentProduct === 'cdrtest' }"
                            >
                                CDR Test Suite Dashboard
                            </a>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li><h6 class="dropdown-header">External Links</h6></li>
                        <li><a class="dropdown-item" href="https://www.productcloud.com.au" target="_blank">
                            ProductCloud
                        </a></li>
                        <li>
                            <a class="dropdown-item" href="https://www.productcloud.com.au" target="_blank">
                            ZenDesk Portal
                        </a></li>
                    </ul>
                </div>
            </div>
            <div v-if="showSecure" class="navbar-nav me-4 mt-0.5">
                <div class="dropright">
                    <button type="button" class="header-dropdown user-button user-initial p-2" data-bs-toggle="dropdown" aria-expanded="false">
                        <span class="user-initial">{{ userInitials }}</span>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <router-link v-if="isLoggedIn" to="/logout" class="dropdown-item btn btn-neutral btn-icon d-flex align-items-center">
                                <LogoutOutlined class="me-2"/>
                                <span>Log Out</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>
<script lang="ts">
import {defineComponent, computed } from 'vue';
import {
    LoginOutlined,
    LogoutOutlined,
    AppstoreOutlined
} from '@ant-design/icons-vue';
import store from '@/store';
import { useRouter } from 'vue-router';

export default defineComponent({
    name: 'app-header',
    components: {
        LoginOutlined,
        LogoutOutlined,
        AppstoreOutlined
    },
    setup() {
        const router = useRouter()

        const showSignIn = computed((): Boolean => {
            return store.state.showSignIn
        })

        const showSecure = computed((): Boolean => {
            return store.state.showSecure
        })

        const isLoggedIn = computed((): Boolean => {
            return !store.state.$auth.loading && store.state.$auth.isAuthenticated
        })

        const user:any = computed(() => {
            return store.state.currentUser
        })

        const userInitials = computed((): string => {
            if (user.value) {
                if (user.value.firstName && user.value.lastName) {
                    return user.value.firstName[0] + user.value.lastName[0];
                } else if (user.value.firstName && ! user.value.lastName) {
                    return user.value.firstName
                } else return '??'
            } else {
                return '??';
            }
        });

        const currentProduct = computed(() => store.state.currentProduct)

        const switchToDashboard = (product: 'productcloud' | 'bankwatch' | 'cdrtest') => {
            store.commit('setCurrentProduct', product)

            // Navigate to the product-specific landing page
            if (product === 'productcloud') {
                router.push('/landing')
            } else if (product === 'bankwatch') {
                router.push('/bankwatch/landing')
            } else if (product === 'cdrtest') {
                router.push('/cdr-test/dashboard')
            }
        }

        return {
            showSignIn,
            showSecure,
            isLoggedIn,
            user,
            userInitials,
            currentProduct,
            switchToDashboard
        }
    }
}) 

</script>
<style lang="scss">
.header-global {
    border-bottom: 1px solid #e5e5e7;
    background: #ffffff;
    .navbar {
        padding-top: 0;
        padding-bottom: 0;
    }
    .nav-brand {
        width: 200px;
    }
    .header-dropdown {
        background: transparent;
        border: 0;
        padding: 0;
        line-height: 0;
    }
    .user-button {
        color: #333;
        &:focus, &:active, &:hover {
            color: #333 !important;
            background: transparent;
            border: 0;
        }
        &.dropdown-toggle {
            background: transparent !important;
            background-color: transparent !important;
            border-color: transparent !important;
        }
    }
    .features-button {
        color: #333;
        font-size: 24px;
    }
    .user-initial {
        color: #333;
        box-shadow: none;
        background: white;
        background-color: white;
        &:focus, &:hover {
            box-shadow: none;
        }
    }

    .btn-header-signin {
        background: #007aff;
        color: white;
        border: none;
        padding: 0.65rem 1.5rem;
        border-radius: 10px;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 1px 4px 0 rgba(0, 122, 255, 0.3);
        text-decoration: none;
        display: inline-flex;
        align-items: center;

        &:hover {
            background: #0051d5;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px 0 rgba(0, 122, 255, 0.4);
            color: white;
            text-decoration: none;
        }

        &:active {
            transform: translateY(0);
        }
    }

    /* Dropdown Menu Styles */
    .dropdown-menu {
        min-width: 240px;
        padding: 8px 0;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border: 1px solid #E0E0E0;
    }

    .dropdown-header {
        color: #6c757d;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 8px 16px 4px 16px;
        margin-top: 4px;
    }

    .dropdown-divider {
        margin: 8px 0;
        border-color: #E0E0E0;
    }

    .dropdown-item {
        padding: 10px 16px;
        font-size: 14px;
        transition: all 0.2s ease;
        cursor: pointer;
        position: relative;
        border-left: 3px solid transparent;

        &:hover {
            background-color: #F8F9FA;
            padding-left: 20px;
        }

        &.active {
            background: linear-gradient(90deg, rgba(3, 54, 61, 0.1) 0%, rgba(3, 54, 61, 0.05) 100%);
            color: #03363D;
            font-weight: 600;
            border-left-color: #03363D;
            padding-left: 20px;

            &:hover {
                background: linear-gradient(90deg, rgba(3, 54, 61, 0.15) 0%, rgba(3, 54, 61, 0.08) 100%);
                color: #03363D;
            }
        }
    }
}
</style>
